const demandIndex = r => require.ensure([], () => r(require('@/page/demandMge/demandIndex')), 'demandIndex');
const dataModifyApplyList = r => require.ensure([], () => r(require('@/page/demandMge/dataModifyApply/dataModifyApplyList')), 'dataModifyApplyList');
const funcModuleList = r => require.ensure([], () => r(require('@/page/demandMge/funcModule/funcModuleList')), 'funcModuleList');
const funcOptiApplyList = r => require.ensure([], () => r(require('@/page/demandMge/funcOptiApply/funcOptiApplyList')), 'funcOptiApplyList');
const reviewIndex = r => require.ensure([], () => r(require('@/page/demandMge/reviewList/reviewIndex')), 'reviewIndex');
const funcOptiDetail = r => require.ensure([], () => r(require('@/page/demandMge/funcOptiApply/funcOptiDetail')), 'funcOptiDetail');
const dataModifyDetail = r => require.ensure([], () => r(require('@/page/demandMge/dataModifyApply/dataModifyDetail')), 'dataModifyDetail');
const dataModifyCheck = r => require.ensure([], () => r(require('@/page/demandMge/reviewList/dataModifyCheck')), 'dataModifyCheck');
const funcOptiApplyCheck = r => require.ensure([], () => r(require('@/page/demandMge/reviewList/funcOptiApplyCheck')), 'funcOptiApplyCheck');

const demandMgeRouter = {
  path: '',
  name: '需求管理',
  component: demandIndex,
  meta: {
    icon: 'demand',
    right: ['需求管理'],
    isShowMenu: true,
    keepAlive:false,
},
  children: [{
    path: '/reviewIndex',
    component: reviewIndex,
    name: '审核列表',
    meta: {
      right: ['审核列表'],
      isShowMenu: true,
      keepAlive:false,
    },
  }, {
    path: '/funcOptiApplyList',
    component: funcOptiApplyList,
    name: '功能优化申请',
    meta: {
      right: ['功能优化申请'],
      isShowMenu: true,
      keepAlive: false,
    },
  }, {
    path: '/dataModifyApplyList',
    component: dataModifyApplyList,
    name: '数据修改申请',
    meta: {
      right: ['数据修改申请'],
      isShowMenu: true,
      keepAlive: false,
    },
  }, {
    path: '/funcModuleList',
    component: funcModuleList,
    name: '数据字典',
    meta: {
      right: ['数据字典'],
      isShowMenu: false,
      keepAlive: false,
    },
  },{
    path: '/funcOptiDetail',
    component: funcOptiDetail,
    name: '功能优化申请详情',
    meta: {
      right: ['功能优化申请详情'],
      isShowMenu: false,
      keepAlive: false,
    },
  },{
    path: '/dataModifyDetail',
    component: dataModifyDetail,
    name: '数据修改申请详情',
    meta: {
      right: ['数据修改申请详情'],
      isShowMenu: false,
      keepAlive: false,
    },
  },{
    path: '/funcOptiApplyCheck',
    component: funcOptiApplyCheck,
    name: '功能优化申请办理',
    meta: {
      right: ['功能优化申请办理'],
      isShowMenu: false,
      keepAlive: false,
    },
  },{
    path: '/dataModifyCheck',
    component: dataModifyCheck,
    name: '数据修改申请办理',
    meta: {
      right: ['数据修改申请办理'],
      isShowMenu: false,
      keepAlive: false,
    },
  }]
};
export default demandMgeRouter;
